import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import Users from './Users';
import User from './User';

export default function UserPage() {
    return (
        <Switch>
            <Route exact path="/users/:userId(\w+)" component={User}/>
            <Route path="/users" component={Users}/>
            <Redirect to="/users"/>
        </Switch>
    );
}
